import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
  titleText: (theme) => ({
    fontSize: 18,
    color: theme ? theme.colors.textColor : 'black'
  }),
  priceText: (theme) => ({
    paddingTop: 2,
    fontSize: 16,
    color: theme ? theme.colors.textColor : 'black'
  }),
  cardStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 0,
    marginTop: 0,
    marginVertical: 16
  }
})

export default styles
